import { CoverImagePanelAction, CoverImagePanelActionKeys } from './actions';
import { Api } from '../../typings/api';

export interface CoverImagePanelState {
	isDisplayed: boolean;
	driveItem: Api.DriveItem | null;
}

const initialState: CoverImagePanelState = {
	isDisplayed: false,
	driveItem: null,
};

export const coverImagePanel = (state: CoverImagePanelState = initialState, action: CoverImagePanelAction): CoverImagePanelState => {
	switch (action.type) {
		case CoverImagePanelActionKeys.OPEN_PANEL:
			return {
				...state,
				isDisplayed: true,
				driveItem: action.driveItem,
			};
		case CoverImagePanelActionKeys.CLOSE_PANEL:
			return initialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CoverImagePanel/reducer.ts